import React, { useState, useEffect } from "react";
import BookingCard from "./BookingCard";
import { useTranslation } from "react-i18next";
import { fetchSiteServices } from "../../services/api";

const FALLBACK_SERVICES = [
  {
    id: "f1",
    title: { uk: "Звукозапис", en: "Sound recording" },
    description: {
      uk: "Записуй голос та інструменти для своїх пісень, подкастів, реклами чи інших творчих проектів",
      en: "Record voice and instruments for your songs, podcasts, commercials or other creative acts",
    },
    price: 700,
    pricing_type: "hourly",
  },
  {
    id: "f2",
    title: { uk: "Зведення/Майстеринг", en: "Mixing/Mastering" },
    description: {
      uk: "Обробка твоїх аудіофайлів для покращення якості звуку та підготовки до релізу на цифрових платформах",
      en: "Processing of your audio files to improve sound quality and prepeare for release on digital platforms",
    },
    price: 2000,
    pricing_type: "project",
  },
  {
    id: "f3",
    title: { uk: "Репетиція", en: "Rehearsal" },
    description: {
      uk: "Готуйся до концертів, виступів або просто покращуй музичні навички як самостійно, так і з гуртом до 10 музикантів",
      en: "Prepare for concerts, performances or simply improve musical skills eather independently or with a band of up to 10 musicians",
    },
    price: 200,
    pricing_type: "hourly",
  },
  {
    id: "f4",
    title: { uk: "Прокат", en: "Rental" },
    description: {
      uk: "Оренда обладнання для концертів, весіль та інших свят",
      en: "Rent equipment for concerts, weddings and other holidays",
    },
    price: 3000,
    pricing_type: "daily",
  },
];

const PRICING_TYPE_LABELS = {
  hourly:  { uk: "за годину",  en: "an hour"    },
  project: { uk: "за проєкт", en: "a project"   },
  daily:   { uk: "за день",    en: "a day"       },
};

const Booking = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === "ua" ? "uk" : (i18n.language || "uk");

  const [services, setServices] = useState(FALLBACK_SERVICES);

  useEffect(() => {
    fetchSiteServices()
      .then((data) => {
        if (data && data.length > 0) setServices(data);
      })
      .catch(() => {});
  }, []);

  const getTitle = (service) =>
    (service.title && (service.title[lang] || service.title.uk || service.title.en)) || "";

  const getDescription = (service) =>
    (service.description && (service.description[lang] || service.description.uk || service.description.en)) || "";

  const getPricingLabel = (type) => {
    const labels = PRICING_TYPE_LABELS[type];
    if (!labels) return type;
    return labels[lang] || labels.uk;
  };

  return (
    <div className="container-fluid Booking-section" id="services">
      <h1>{t("Services")}</h1>
      <div className="d-flex flex-column gap-4">
        {services.map((service, index) => (
          <React.Fragment key={service.id}>
            <BookingCard
              title={getTitle(service)}
              dec={getDescription(service)}
              sym={t("From")}
              price={`${Math.round(service.price)}₴`}
              info={getPricingLabel(service.pricing_type)}
            />
            {index < services.length - 1 && <SVGLine />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Booking;

export const SVGLine = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="1"
      viewBox="0 0 1140 1"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-0.000389954 1L0.000488281 0L1140 0L1140 1L-0.000389954 1Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );
};
